// import uirouter from 'angular-ui-router';
import routing from './main.route';
import run from './main.run';

// Definition for controllers & services home module'
import homeController from './main/home/homeController'

export default angular.module('app.homeSuite', [])
.config(routing)

.controller('homeController', homeController)

// Sidebar Construct
.run(run)
.constant("main", [{
	'title' : 'Inicio',
	'icon'  : 'mdi-home mdi-light',
	'url'   : 'app.homeSuite'
}])
.name;



// WEBPACK FOOTER //
// ./src/app/main-start/index.js